var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.useShortName
        ? _c(
            "span",
            {
              class: _vm.isSelected ? "selectedNameText" : "unSelectedNameText"
            },
            [_vm._v(_vm._s(_vm.unit.name))]
          )
        : _vm._e(),
      _vm.useShortName
        ? _c(
            "span",
            {
              class: _vm.isSelected ? "selectedNameText" : "unSelectedNameText"
            },
            [_vm._v(_vm._s(_vm.unit.shortName))]
          )
        : _vm._e(),
      _c(
        "v-chip",
        {
          staticClass: "darken-4",
          attrs: {
            cursor: "pointer",
            color: "blue",
            "text-color": "white",
            disabled: ""
          }
        },
        [_vm._v(_vm._s(_vm.chipText))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }